export default (editor, config = {}) => {
    const bm = editor.BlockManager;
    bm.add('live', {
        label: 'live',
        category: 'Media',
        content: {
            activeOnRender: 1,
            resizable : true,
            type:'live',
            style: {
                width: "640px",
                height: "360px"
            }
        },
        attributes: {
            class:'fa fa-dot-circle-o' //icon in the panel
        }
    });
}





// WEBPACK FOOTER //
// ./src/plugins/live/blocks.js